<template>
  <div class="totale">
    <div class="barside left"></div>
    <div class="barside right"></div>
    <div class="centrale">
      <div id="navigazione">
        <ul class="nav nav-pills nav-justified">
          <li class="nav-item">
            <router-link to="/" class="nav-link" aria-current="page"
              >Home</router-link
            >
          </li>

          <li class="nav-item">
            <router-link to="/about" class="nav-link" aria-current="page"
              >About</router-link
            >
          </li>

          <li class="nav-item">
            <router-link to="/puntate" class="nav-link" aria-current="page"
              >Puntate</router-link
            >
          </li>
        </ul>
      </div>

      <div class="corpo">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
</script>

<style>
.totale {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.centrale {
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #ffe9d5;
  
}

#navigazione {
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  font-size: 2vw;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  top: 0;
  width: 60%;
  margin-left: 20%;
  margin-right: 20%;
  padding-bottom: 1.5%;
  background: #ffe9d5;
  /* padding-bottom: 1.5%; */
}

.nav {
  width: 100%;
}

#navigazione a {
  font-weight: bold;
  color: #2c3e50;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 5px;
  /* border: 2px solid #961313; */
  /* top-right-bottom-left */
  background: #ffe9d5;
  background: #ccb7a4;
}
.nav-item {
  margin: 1.5% 3% 0% 3%;
}

#navigazione a:hover {
  box-shadow: rgba(0, 0, 0, 0.65) 0px 5px 15px;
  /* border: 2px solid #961313; */
}

#navigazione a.router-link-exact-active {
  color: white;
  background: #2c3e50;
  /* border: 2px solid #961313; */
}
html {
  background: #ffe9d5;
}

body::-webkit-scrollbar {
  width: 1em;
}
 
body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #426486;
}
 
body::-webkit-scrollbar-thumb {
  background-color: #2c3e50;
  outline: 1px solid #15202c;
}

.corpo {
  height: 100%;
  width: 100%;
  /* border: 2px solid #961313; */
}

.barside {
  width: 20%;
  /* background: rgb(248, 246, 241); */
  background: #ccb7a4;
  height: 100%; /* Full-height: remove this if you want "auto" height */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 10; /* Stay on top */
  top: 0; /* Stay at the top */
  overflow-x: hidden; /* Disable horizontal scroll */
  box-shadow: rgba(0, 0, 0, 0.7) 0px 0px 10px;
}
.left {
  margin-left: 0%;
  left: 0;
}

.right {
  margin-right: 0%;
  right: 0;
}

@media screen and (max-width: 1000px) {
  .barside {
    width: 0%;
  }
  .corpo {
    width: 100%;
    margin-left: 0%;
  }
  .centrale {
    width: 100%;
  }
  #navigazione {
    background: #ccb7a4;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 5px 5px;
    width: 100%;
    margin-left: 0%;
    margin-right: 0%;
    padding-bottom: 3%;
  }
  #navigazione a {
    background: #ffe9d5;
  }
  .nav-item {
    margin: 3% 3% 0% 3%;
  }
}
@media screen and (max-width: 540px) {
  #navigazione {
    font-size: 7vw;
  }
}
@media screen  and (min-width: 540px) and (max-width: 850px) {
  #navigazione {
    font-size: 5vw;
  }
}

@media screen and (min-width: 850px) and (max-width: 1000px) {
  #navigazione {
    font-size: 4vw;
  }
}
</style>
